import { ALERT_SUCCESS, ALERT_ERROR, ALERT_CLOSE } from '../constants/alertTypes';

const initialState = {
  messages: [],
};

const alert = (state = initialState, action) => {
  switch (action.type) {
    case ALERT_SUCCESS: {
      const { message, uppercase } = action.payload;
      return {
        messages: [
          ...state.messages,
          {
            id: new Date().getTime(),
            success: true,
            text: message,
            uppercase,
          },
        ],
      };
    }

    case ALERT_ERROR: {
      const { message, uppercase } = action.payload;
      return {
        messages: [
          ...state.messages,
          {
            id: new Date().getTime(),
            error: true,
            text: message,
            uppercase,
          },
        ],
      };
    }

    case ALERT_CLOSE: {
      const messages = state.messages.filter((message) => message.id !== action.payload);
      return {
        messages,
      };
    }

    default:
      break;
  }

  return state;
};

export default alert;
